<template>
  <div>
  </div>
</template>
<script>
export default {
  name: "Logout",

  metaInfo: {
    title: process.env.VUE_APP_TITLE + ' / Выход'
  },
  data() {
    return {}
  },
  mounted() {
    let bodyFormData = new FormData();
    bodyFormData.append('method', 'user.logout');
    this.axios.post(process.env.VUE_APP_USER_API_URL + '/ajax', bodyFormData)
      .then((response) => {
        console.debug(response);
        this.$store.commit('logout');
        this.$router.push('/login');
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
</script>
